import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ToggleButton, ToggleButtonGroup } from 'react-bootstrap';

import Tooltip from 'components/tooltip';

import type { IconProp } from '@fortawesome/fontawesome-svg-core';

interface Props {
  options: {
    icon: IconProp;
    label: string;
    value: string;
  }[];
  value: string;
  onChange: (value: string) => void;
}

export default function Toggle({ options, value, onChange }: Props) {
  return (
    <ToggleButtonGroup name="toggle" type="radio" value={value}>
      {options.map(option => (
        <ToggleButton
          key={option.value}
          name={option.value}
          value={option.value}
          onClick={() => onChange(option.value)}
        >
          <Tooltip content={option.label}>
            <FontAwesomeIcon icon={option.icon} />
          </Tooltip>
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
}
